/* INT 2026-11-03 (task wishlist-own-or-swym, cleanup): Swym is uninstalled, so this file keeps ONLY the heart burst
   (mint hearts from the tapped heart) and the call to window.__intHeartLand (the fly-in, assets/int-wishlist-landing.js).
   Removed: the Swym drawer decoration (product.wlcard fetch into .swym-wishlist-item), the Swym title wrap and the
   Swym string table (SwymCallbacks). Old copy: INTENTION_Shared/wishlist-own-2026-11-02/cleanup/orig-main/. */
(function () {
  // Heart buttons that trigger the burst. Confirm/extend for your PDP heart.
  var HEART_SELECTORS = [
    '.collection-swym-heart',
    '.custom-swym-heart',
    '.swym-add-to-wishlist-view-product',
    '.swym-add-to-wishlist',
    '.swym-heart'
  ].join(',');

  // If any of these is present at click time the item is being REMOVED, so skip.
  var ADDED_CLASSES = ['swym-added', 'active', 'swym-loved', 'is-wishlisted'];

  var MINT = '#00FFBF';
  var HEART = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="' + MINT + '"/></svg>';

  var layer = null;
  function getLayer() {
    if (!layer || !document.body.contains(layer)) {
      layer = document.createElement('div');
      layer.className = 'int-heart-burst-layer';
      document.body.appendChild(layer);
    }
    return layer;
  }

  function burst(x, y) {
    var l = getLayer();
    var n = 6 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) {
      var h = document.createElement('span');
      h.className = 'int-heart-burst';
      var dx = (Math.random() * 2 - 1) * 26;
      var dx2 = dx + (Math.random() * 2 - 1) * 18;
      var rot = (Math.random() * 2 - 1) * 28;
      var size = 12 + Math.random() * 10;
      var dur = 0.85 + Math.random() * 0.35;
      h.style.left = x + 'px';
      h.style.top = y + 'px';
      h.style.setProperty('--int-dx', dx + 'px');
      h.style.setProperty('--int-dx2', dx2 + 'px');
      h.style.setProperty('--int-rot', rot + 'deg');
      h.style.setProperty('--int-size', size + 'px');
      h.style.setProperty('--int-dur', dur + 's');
      h.style.animationDelay = (Math.random() * 0.12) + 's';
      h.innerHTML = HEART;
      l.appendChild(h);
      (function (el) {
        setTimeout(function () { el.remove(); }, (dur + 0.4) * 1000);
      })(h);
    }
  }

  function isAdded(el) {
    var label = (el.getAttribute('aria-label') || '').toLowerCase();
    if (label.indexOf('remove') !== -1) return true;
    if (label.indexOf('add to wishlist') !== -1) return false;
    for (var i = 0; i < ADDED_CLASSES.length; i++) {
      if (el.classList.contains(ADDED_CLASSES[i])) return true;
      if (el.querySelector && el.querySelector('.' + ADDED_CLASSES[i])) return true;
    }
    return false;
  }

  function fireAt(btn) {
    var r = btn.getBoundingClientRect();
    if (!r.width && !r.height) return;
    btn.__intBurstTs = Date.now();
    burst(r.left + r.width / 2, r.top + r.height / 2);
    if (typeof window.__intHeartLand === 'function') window.__intHeartLand();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(HEART_SELECTORS) : null;
    if (!btn) return;
    if (isAdded(btn)) return; // removing -> no burst
    fireAt(btn);
  }, true);

  function initHeart(b) { if (b.__intWasAdded === undefined) b.__intWasAdded = isAdded(b); }
  function initAll(root) { (root || document).querySelectorAll(HEART_SELECTORS).forEach(initHeart); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  window.addEventListener('load', function () { initAll(document); });
  initAll(document);

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes, j;
      for (j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (!n || n.nodeType !== 1) continue;
        if (n.matches && n.matches(HEART_SELECTORS)) initHeart(n);
        if (n.querySelectorAll) n.querySelectorAll(HEART_SELECTORS).forEach(initHeart);
      }
    }
  }).observe(document.body, { subtree: true, childList: true });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (!t || !t.matches || !t.matches(HEART_SELECTORS)) continue;
      var added = isAdded(t);
      var was = t.__intWasAdded;
      t.__intWasAdded = added;
      if (was === false && added === true) {
        var recent = t.__intBurstTs && (Date.now() - t.__intBurstTs) < 1500;
        if (!recent) fireAt(t);
      }
    }
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-label'] });
})();
